/* eslint-disable */
import React, { useState, useEffect } from "react";
import ActionButton from '../../framework/forms/helpercomponents/buttons/ActionButton';
import { DropDownList } from "@progress/kendo-react-dropdowns";
import * as API from "../../framework/API/api";
import { ENTITYNAME, MEDIACATEGORIES, MEDIA_TRANSMISSION, TOAST_TYPES } from "../../framework/constant/constant";
import { useTranslation } from "../../locale/useTranslation";
import MyMultiSelect from "../../components/MyMultiSelect";
import BossDialog from "../../components/BossDialog";
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import ToastNotification from "../../components/ToastNotification";

export const FormatFilterTemplate = (props) => {

    const { closeFilterPopup, filterDataItem, isFilterCleared, setIsFilterCleared, editMode = false, mediaCategorySID = null } = props;

    const lang = useTranslation();
    const blankDataItem = {
        Genres: [],
        PGRating: [],
        MediaCategory: [],
        ReleaseYear: '',
        Languages: [],
        CastName: '',
        CastType: {},
        isLive: false,
        CreatedFrom: '',
        CreatedTo: '',
        publishingStartDate: '',
        publishingEndDate: '',
        Transmission: { _id: 0, Description: "All" },
        CastAndCrew: [],
    }
    const [dataItem, setDataItem] = useState(blankDataItem);

    const [genre, setGenre] = useState([]);
    const [mediaCategory, setMediaCategories] = useState([]);
    const [language, setLanguage] = useState([]);
    const [castType, setCastType] = useState([]);
    const [pgRating, setPGRating] = useState([]);

    useEffect(() => {
        loadCombo();
    }, [filterDataItem]);

    const loadCombo = async () => {

        let mediaCategory = await API.getDataLookup(ENTITYNAME.MediaCategory, { sort: { Description: 1 } });
        let filteredMediaCategory = mediaCategory.data.filter(item => item.isLong == true && item.SID != MEDIACATEGORIES.Series);

        let planningSlotMediaCategory = filteredMediaCategory.filter(x => x.SID == MEDIACATEGORIES.Movie || x.SID == MEDIACATEGORIES.Program || x.SID == MEDIACATEGORIES.Episode);
        setMediaCategories(planningSlotMediaCategory);

        let genres = await API.getDataLookup(ENTITYNAME.Genre, { sort: { Description: 1 } });
        setGenre(genres.data);
        let language = await API.getDataLookup(ENTITYNAME.Language, { sort: { Description: 1 } });
        setLanguage(language.data);
        let castType = await API.getDataLookup(ENTITYNAME.CastType, { sort: { Description: 1 } });
        setCastType(castType.data);
        let pGRating = await API.getDataLookup(ENTITYNAME.PGRating, { sort: { Description: 1 } });
        setPGRating(pGRating.data);

        setDataItem({ ...blankDataItem, ...filterDataItem });
    }

    const onChange = (e) => {
        setDataItem({ ...dataItem, [e.target.name]: e.target.value });
        isFilterCleared && setIsFilterCleared(false);
    }

    const onSearchClick = async () => {

        if (dataItem.ReleaseYear && dataItem.ReleaseYear.toString().length != 4) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_enter_valid_release_year_error_message });
            return;
        }

        let finalData = isFilterCleared ? {} : {
            ...dataItem,
            MediaCategory: dataItem.MediaCategory.map((x) => { return { _id: x._id, SID: x.SID, Description: x.Description, isLong: x.isLong } }),
            Genres: dataItem.Genres.map((x) => { return { _id: x._id, SID: x.SID, Description: x.Description } }),
            Languages: dataItem.Languages.map((x) => { return { _id: x._id, SID: x.SID, Description: x.Description } }),
            PGRating: dataItem.PGRating.map((x) => { return { _id: x._id, SID: x.SID, Description: x.Description } })
        }

        props.toGetFilterDataItem && props.toGetFilterDataItem(finalData);
        props.closeFilterPopup && props.closeFilterPopup();

    }

    const onClear = () => {
        setDataItem(blankDataItem);
        props.onClear && props.onClear();
        setIsFilterCleared && setIsFilterCleared(true);
    }

    const addCastAndCrew = () => {
        if (!dataItem.CastName && dataItem.CastName.length == 0) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_enter_cast_name_error_message });
            return;
        }
        if (!dataItem.CastType && Object.keys(dataItem.CastType).length == 0) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_cast_type_error_message });
            return;
        }

        let castAndCrewFilters = [...dataItem.CastAndCrew, { CastName: dataItem.CastName, CastType: dataItem.CastType }];
        setDataItem({ ...dataItem, CastName: "", CastType: {}, CastAndCrew: castAndCrewFilters });
    }

    return (
        <BossDialog
            title={lang.format_rule_header}
            onClose={closeFilterPopup}
            width={"26.5%"}
            height={"100vh"}
            overlayClassName={"right-drawer"}
            overlayStyle={{ pointerEvents: 'none', background: 'none' }}
            style={{
                pointerEvents: 'auto',
                height: "100vh",
                maxHeight: "100vh",
                display: "flex",
                flexDirection: "column",
                borderRadius: 0,
                overflowY: "auto",
                borderLeft: "1px solid #ccc",
            }}
        >
            <div className="row">
                <div className="col-12">
                    <ActionButton title={props.saveButtonName ?? lang.search_button_tooltip} name={props.saveButtonName ?? lang.search_button_text} onClick={onSearchClick} />
                    <ActionButton title={lang.clear_button_tooltip} name={lang.clear_button_text} btnColor={"danger"} onClick={onClear} />
                </div>
            </div>
            <div className='row mt-3 flex-grow-1' style={{ marginLeft: "-02px", marginRight: "0px", minHeight: "calc(100vh - 140px)" }}>
                <div className="col-12 border rounded" style={{ backgroundColor: "#ffffff", minHeight: "100%", padding: "15px" }}>
                    <div className="row">
                        <div className="col-4">
                            <label htmlFor="TabView">{lang.media_category_label} : </label>
                        </div>
                        <div className="col-8">
                            <div className="form-group">
                                <MyMultiSelect
                                    data={mediaCategory}
                                    name="MediaCategory"
                                    textField="Description"
                                    dataItemKey="_id"
                                    value={dataItem.MediaCategory}
                                    onChange={onChange}
                                    disabled={props.disableMediaCategory ?? false}
                                />
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-4">
                            <label htmlFor="TabView">{lang.transmission_label} : </label>
                        </div>
                        <div className="col-8">
                            <div className="form-group">
                                <DropDownList
                                    data={[
                                        { _id: 0, Description: "All" },
                                        ...Object.keys(MEDIA_TRANSMISSION).map((key) => ({ _id: MEDIA_TRANSMISSION[key], Description: key }))
                                    ]}
                                    name="Transmission"
                                    textField="Description"
                                    dataItemKey="_id"
                                    value={dataItem.Transmission}
                                    onChange={onChange}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-4">
                            <label htmlFor="TabView">{lang.genre_label} : </label>
                        </div>
                        <div className="col-8">
                            <div className="form-group">
                                <MyMultiSelect
                                    data={genre}
                                    name="Genres"
                                    textField="Description"
                                    dataItemKey="_id"
                                    value={dataItem.Genres}
                                    onChange={onChange}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-4">
                            <label htmlFor="TabView">{lang.language_label} :</label>
                        </div>
                        <div className="col-8">
                            <div className="form-group">
                                <MyMultiSelect
                                    data={language}
                                    name="Languages"
                                    textField="Description"
                                    dataItemKey="_id"
                                    value={dataItem.Languages}
                                    onChange={onChange}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-4">
                            <label htmlFor="TabView">{lang.pg_rating_label} :</label>
                        </div>
                        <div className="col-8">
                            <div className="form-group">
                                <MyMultiSelect
                                    data={pgRating}
                                    name="PGRating"
                                    textField="Description"
                                    dataItemKey="_id"
                                    value={dataItem.PGRating}
                                    onChange={onChange}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-4">
                            <label htmlFor="TabView">{lang.cast_and_crew_label} : </label>
                        </div>
                        <div className="col-8">
                            <div className="row">
                                <div className="col-6 form-group" style={{ paddingRight: '5px' }}>
                                    <input type="text" className="form-control form-control-sm" name="CastName" value={dataItem.CastName} onChange={onChange} />
                                </div>
                                <div className="col-6 form-group" style={{ paddingLeft: '5px' }}>
                                    <div style={{ display: 'flex' }}>
                                        <DropDownList
                                            data={castType}
                                            name="CastType"
                                            textField="Description"
                                            dataItemKey="_id"
                                            value={dataItem.CastType}
                                            onChange={onChange}
                                        />
                                        <button type="button" title={lang.add_cast_and_crew_tooltip} className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-primary "
                                            style={{ height: "29px", margin: '0px 0px 0px 5px' }} onClick={addCastAndCrew}><i className="fa-solid fa-plus fa-xs"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {dataItem.CastAndCrew && dataItem.CastAndCrew.length > 0 && <div className="row">
                        <div className="col form-group">
                            <Grid data={dataItem.CastAndCrew}>
                                <GridColumn field="CastName" title={lang.name_label} />
                                <GridColumn field="CastType.Description" title={lang.cast_type_label} />
                            </Grid>
                        </div>
                    </div>}
                    <div className="row">
                        <div className="col-4">
                            <label htmlFor="TabView">{lang.production_year_label} :</label>
                        </div>
                        <div className="col-4" style={{ paddingRight: '5px' }}>
                            <div className="form-group">
                                <input
                                    type="number"
                                    className="form-control form-control-sm"
                                    name="ReleaseYear"
                                    value={dataItem.ReleaseYear}
                                    onChange={onChange}
                                    min={0}
                                />
                            </div></div>
                    </div>
                    <div className="row">
                        <div className="col-4">
                            <label htmlFor="TabView">{lang.is_live_label} :</label>
                        </div>
                        <div className="col-8">
                            <div className="form-group">
                                <input
                                    name="isLive"
                                    type="checkbox"
                                    value={dataItem.isLive}
                                    checked={dataItem.isLive}
                                    onChange={onChange}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </BossDialog>
    );
};
